/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAirdropTicketTip.vue?vue&type=template&id=5311b5a3&scoped=true"
import script from "./popAirdropTicketTip.vue?vue&type=script&lang=js"
export * from "./popAirdropTicketTip.vue?vue&type=script&lang=js"
import style0 from "./popAirdropTicketTip.vue?vue&type=style&index=0&id=5311b5a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5311b5a3",
  null
  
)

export default component.exports